import { render } from "./Partners.vue?vue&type=template&id=d3718ca6&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=ts"
export * from "./Partners.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-d3718ca6"

export default script